/*
 * @Author: bbqin
 * @Date: 2023-05-19 16:21:33
 * @LastEditTime: 2023-08-01 14:23:13
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\SmartCard\components\message\index.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import { broadcast, getDecryptData, getAppUrl, setGlobalStorage, getGlobalStorage, removeGlobalStorage } from '@platform/api';
import { isFunction } from '../../libs/utils';
import Portal from '../portal';

const windowForSonar = window;

export class Message {

    static Name = {
        mount: 'mount',
        channel: 'channel',
        feedback: 'feedback',
        pagePortal: 'pagePortal',
    }

    constructor(props) {
        // TODO 一个唯一的Id，避免当前页面的通信，影响了其他界面
        this.pageUniqueId = Portal.getPageUniqueId();
        this.callbacks = {};
        this.pageUniqueId && windowForSonar.addEventListener('storage', this._receive, false);
    }

    _receive = e => {
        // 只触发当前页面的
        // localStorage.setItem時  pageUniqueId   如 localStorage.setItem('pageUniqueId XXXX')
        let key = e.key;
        if (String(key).match(this.pageUniqueId) && this.callbacks[key]) {
            // let value = getDecryptData(e.newValue) || getGlobalStorage('localStorage', key);
            let value = getDecryptData(e.newValue);
            let obj = value ? JSON.parse(value) : '';
            obj && this.callbacks[key].forEach(function (fn) {
                fn(obj, key);
            });
        }
    }

    // 做成方法，为了以后可能的扩展
    getName(name, uniqueId) {
        return Message.Name[name];
    }

    // 订阅消息
    subscribe(topic = '', fn, unique = true) {
        topic = topic + this.pageUniqueId;
        if (isFunction(fn)) {
            if (!this.callbacks[topic] || unique) {
                this.callbacks[topic] = [];
            }
            this.callbacks[topic].push(fn);
        }
    }

    // 取消订阅
    unsubscribe(topic = '', fn) {
        topic = topic + this.pageUniqueId;
        if (isFunction(fn)) {
            if (this.callbacks[topic]) {
                if (fn) {
                    for (var i = this.callbacks[topic].length; i--;) {
                        if (this.callbacks[topic][i] == fn) {
                            this.callbacks[topic].splice(i, 1);
                        }
                    }
                } else {
                    this.callbacks[topic] = [];
                }
            }
        }
    }

    clear() {
        window.removeEventListener('storage', this._receive);
        if (this.callbacks) {
            this.callbacks = {};
        }
    }

    // 发布消息
    publish(topic = '', message) {
        topic = topic + this.pageUniqueId;

        // 避免本地满了，坐下try catch 清理一部分数据，保证能发布消息
        try {
            setGlobalStorage('localStorage', topic, JSON.stringify(message));
            // clean up localstorage
            setTimeout(function () {
                removeGlobalStorage('localStorage', topic);
            }, 0);
        } catch (error) {
            console.error(error);
            Object.keys(localStorage).forEach(item => {
                if (item.includes('appTempletStorage_')) {
                    delete localStorage[item];
                }
            });
            // 再次尝试设置值
            try {
                setGlobalStorage('localStorage', topic, JSON.stringify(message));
                // clean up localstorage
                setTimeout(function () {
                    removeGlobalStorage('localStorage', topic);
                }, 0);
            } catch (error) {
                console.error(error);
            }
        }
    }

    // 获取传递的数据
    getResponseData(name) {
        name = name + this.pageUniqueId;
        const result = getGlobalStorage(name);
        // 避免占用空间，移除
        removeGlobalStorage(name);
        return result;
    }

    // 获取传递的数据
    setResponseData(name, value) {
        name = name + this.pageUniqueId;

        // 避免本地满了，坐下try catch 清理一部分数据，保证能发布消息
        try {
            setGlobalStorage(name, value);
        } catch (error) {
            console.error(error);
            Object.keys(localStorage).forEach(item => {
                if (item.includes('appTempletStorage_')) {
                    delete localStorage[item];
                }
            });
            try {
                setGlobalStorage(name, value);
            } catch (error) {
                console.error(error);
            }
        }
    }

    static getInstance() {
        return new Message();
    }
}

export const MessageObj = Message.getInstance();

MessageObj.Message = Message;

export default MessageObj;
